import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoltRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.663 1.622a.75.75 0 0 1 .3.862L12.125 8h3.778a1.096 1.096 0 0 1 .731 1.913L7.25 18.309a.75.75 0 0 1-1.213-.794L7.876 12H4.097a1.096 1.096 0 0 1-.731-1.912L12.75 1.69a.75.75 0 0 1 .912-.07M5.153 10.5h3.763a.75.75 0 0 1 .712.988l-1.275 3.821L14.847 9.5h-3.763a.75.75 0 0 1-.712-.987l1.275-3.822z" })
});
export default SvgBoltRegularIcon;
